/**
 * For Google Tag Manager
 */
'use strict';

var root = typeof window === 'undefined' ? global : window;
root.dataLayer = root.dataLayer || [];
module.exports = root.dataLayer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-tracking/gtmDataLayer.js
// module id = ./node_modules/dibs-tracking/gtmDataLayer.js
// module chunks = 4